import * as actionTypes from '../types/processing';

const initialState = {
  okRequest: false,
  loading: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_PROCESSING_START:
      return {
        ...state,
        loading: true,
        okRequest: false
      };
    case actionTypes.GET_PROCESSING_START_SUCCESS:
      return {
        ...state,
        loading: false,
        okRequest: true
      };
    case actionTypes.GET_PROCESSING_START_FAIL:
      return {
        ...state,
        loading: false
      };

    case actionTypes.GET_PROCESSING_START_CANCEL:
      return {
        ...state,
        loading: true,
        okRequest: false
      };
    case actionTypes.GET_PROCESSING_START_CANCEL_SUCCESS:
      return {
        ...state,
        loading: false,
        okRequest: true
      };
    case actionTypes.GET_PROCESSING_START_CANCEL_FAIL:
      return {
        ...state,
        loading: false
      };
    case actionTypes.GET_PROCESSING_START_CLEAR:
      return {
        ...state,
        okRequest: false,
        loading: false
      };

    case actionTypes.GET_AWAITING_PROCESSING_START:
      return {
        ...state,
        loading: true,
        okRequest: false
      };
    case actionTypes.GET_AWAITING_PROCESSING_START_SUCCESS:
      return {
        ...state,
        loading: false,
        okRequest: true
      };
    case actionTypes.GET_AWAITING_PROCESSING_START_FAIL:
      return {
        ...state,
        loading: false
      };

    default:
      return state;
  }
};

export default reducer;
